<template>
  <van-empty
    v-if="currentGameId === 186"
    :description="$t('options.战双提示')"
  />
  <div class="rebind-phone" v-else>
    <NavBar
      class="nav"
      :title="$t('options.手机换绑')"
      :goBack="
        () => {
          this.$router.go(-1);
        }
      "
    />
    <van-notice-bar :text="$t('options.换绑前请确保当前手机号')" />
    <div v-if="curStep === 0" class="form-content">
      <van-form validate-first @submit="onSubmit">
        <div class="field-item">
          <span class="label"
            ><span class="red">* </span>{{ $t("options.当前手机号") }}：</span
          >
          <van-field
            v-model="form.phone"
            type="tel"
            class="input-field"
            :name="$t('options.当前手机号')"
            :placeholder="$t('options.请输入现绑定手机号码')"
            :rules="[
              {
                pattern: phonePattern,
                message: $t('options.请输入正确的手机号码'),
              },
            ]"
          />
        </div>
        <div class="field-item">
          <span class="label"
            ><span class="red">* </span>{{ $t("options.当前手机号") }}：</span
          >
          <van-field
            v-model="form.new_phone"
            type="tel"
            class="input-field"
            :name="$t('options.新手机号')"
            :placeholder="$t('options.请输入新手机号码')"
            :rules="[
              {
                pattern: phonePattern,
                message: $t('options.请输入正确的手机号码'),
              },
            ]"
          />
        </div>

        <div style="margin: 16px;">
          <van-button
            class="submit-btn"
            block
            type="primary"
            size="large"
            native-type="submit"
          >
            {{ $t("options.下一步") }}
          </van-button>
        </div>
      </van-form>
    </div>

    <send-msg
      v-else-if="curStep === 1"
      :form="form"
      :code="code"
      @sendMsg="handleSendMsg"
    />
    <valid-phone
      v-else-if="curStep === 2"
      :content="code"
      :form="form"
      @submit="handleCodeSubmit"
      @handleBack="handleBack"
    />
    <success :form="form" v-else />
  </div>
</template>

<script>
import SendMsg from "./modules/sendMsg.vue";
import ValidPhone from "./modules/validPhone.vue";
import Success from "./modules/success.vue";
import { apiGetBindPhoneCode } from "@/api/user";

export default {
  name: "ReBindPhone",
  components: { SendMsg, ValidPhone, Success },
  data() {
    return {
      // $t('当前步骤')
      curStep: 0,
      phonePattern: /^1[3456789]\d{9}$/,
      form: {
        phone: "",
        new_phone: "",
      },
      currentGameId: "",
      submitLoading: false,
      code: undefined,
    };
  },
  created() {
    const { game_id } = this.$route.query;
    if (game_id) {
      this.currentGameId = Number(game_id);
      sessionStorage.setItem("game_id", Number(game_id));
    } else {
      const game_id = sessionStorage.getItem("game_id");

      this.currentGameId = game_id ? Number(game_id) : "";
    }
  },
  mounted() {
    if (this.currentGameId !== 186) {
      this.$dialog.alert({
        title: this.$t("options.风险提示"),
        message: this.$t("options.rebindTips"),
      });
    }
  },
  methods: {
    onSubmit() {
      const { phone, new_phone } = this.form;
      if (phone === new_phone) {
        this.$toast(this.$t("options.手机号不能相同"));
        return;
      }
      this.submitLoading = true;
      apiGetBindPhoneCode({
        old_phone: phone,
        new_phone,
      })
        .then((res) => {
          if (res.code === 0) {
            // console.log(res);
            this.code = res.data;
            if (res.data) {
              this.curStep += 1;
            }
          }
        })
        .finally(() => {
          this.submitLoading = false;
        });
      // this.curStep += 1;
    },
    handleSendMsg() {
      this.curStep += 1;
    },
    handleBack() {
      this.curStep -= 1;
    },
    handleCodeSubmit() {
      this.curStep += 1;
    },
  },
};
</script>

<style lang="less" scoped>
.rebind-phone {
  width: 100%;
}
</style>
